import BiocFacade from '@baidu/bioc-jssdk';

const ak = 't1uVzbGKYQp6yN935liYNW0tCRrsTJi8'; // 联系管理员申请获取

// 使用 let 以支持在 showCaptcha 时重新创建实例（重置 SDK 内部验证状态）
let captcha = BiocFacade.createCaptcha({ak});

type CaptchaResolver = {
    resolve: (stk: string) => void;
    reject: (err: Error) => void;
};

let captchaResolvers: CaptchaResolver[] = [];

function flushResolvers(success: boolean, stk?: string, err?: Error) {
    const resolvers = captchaResolvers.splice(0);
    if (success) {
        resolvers.forEach(r => r.resolve(stk!));
    } else {
        resolvers.forEach(r => r.reject(err ?? new Error('验证失败')));
    }
}

/**
 * 为 captcha 实例注册所有事件回调
 * 每次重新创建实例后需要重新调用
 */
function bindCallbacks() {
    captcha.onSuccess((token: { stk: string }) => {
        document.cookie = `svcp_stk=${token.stk}; expires=${new Date(Date.now() + 60000).toUTCString()};path=/`;
        flushResolvers(true, token.stk);
    });
    captcha.onFail(() => {
        flushResolvers(false, undefined, new Error('验证码验证失败'));
    });
    captcha.onClose(() => {
        flushResolvers(false, undefined, new Error('用户关闭了验证码'));
    });
    captcha.onError((e: Error) => {
        console.log(e.toString(), 'err captcha');
        flushResolvers(false, undefined, e);
    });
}

// 初始化时注册一次回调
bindCallbacks();

/**
 * 订阅一次验证码结果，返回 Promise：
 * - 验证成功时 resolve(stk)，携带验证码 token
 * - 验证失败 / 关闭 / 错误时 reject
 * 并发调用时所有订阅者共享同一次验证过程
 */
export const subscribeCaptchaResult = (): Promise<string> => {
    return new Promise((resolve, reject) => {
        captchaResolvers.push({ resolve, reject });
    });
};

/**
 * 展示验证码弹窗
 * 每次调用前关闭旧实例并重新创建，确保 SDK 状态是全新的，
 * 避免复用上次验证成功的状态导致 onSuccess 被立刻触发
 */
export const showCaptcha = () => {
    captcha.close();
    captcha = BiocFacade.createCaptcha({ak});
    bindCallbacks();
    captcha.showPopup();
};

export const closeCaptcha = () => {
    captcha.close();
};
